module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-192x192.d7f6729ffb12b4e1e202849425be7c34.png";